<template>
<!--   <div class="test"> -->
<!--     <ul class="sample"> -->
<!--       <li> -->
<!--         <NuxtLink to="/portal/user/main/user_main"> -->
<!--           사용자 메인페이지 이동 -->
<!--         </NuxtLink> -->
<!--       </li> -->
<!--       <li> -->
<!--         <NuxtLink to="/portal/manager/portalMgmt/memberMgmt/general/general_list"> -->
<!--           관리자 메인페이지 이동 -->
<!--         </NuxtLink> -->
<!--       </li> -->
<!--       <li> -->
<!--         <NuxtLink to="/portal/user/login/user_login"> -->
<!--           로그인 페이지 이동 -->
<!--         </NuxtLink> -->
<!--       </li> -->
<!--     </ul> -->
<!--   </div> -->
</template>
<script>

export default {

	beforeCreate() {
		this.$router.push( "/portal/user/main/user_main" );
	}
}
</script>
<style lang="scss" scoped>
.sample {
  padding: 30px 40px;

  li {
    margin: 10px 0;
    font-size: 30px;

    a {
      color: #000;
    }

    .disabled {
      color: red;
      cursor: initial;

    }
  }
}
</style>

